/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Campaign
 */
export interface Campaign {
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  authorId?: string;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  authorKey?: string;
  /**
   * The phone number to use as caller id
   * @type {string | null}
   * @memberof Campaign
   */
  callerId?: string | null;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  campaignId?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  companyId: number;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateArchived?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateArchivedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateAudienceComputed?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateAudienceComputedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateComputed?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateComputedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateEnded?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateEndedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  datePaused?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  datePausedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateScheduledEnd?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateScheduledEndIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateScheduledStart?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateScheduledStartIso?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  dateStarted?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  dateStartedIso?: string;
  /**
   * Description of Campaign
   * @type {string}
   * @memberof Campaign
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  flowId?: string;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  flowKey?: string;
  /**
   * GCS filename for campaign result
   * @type {string}
   * @memberof Campaign
   */
  gcsFilename?: string;
  /**
   *
   * @type {number}
   * @memberof Campaign
   */
  groupId?: number;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  id: string;
  /**
   * If the campaign should dynamically create lead list items from an audience
   * @type {boolean}
   * @memberof Campaign
   */
  isDynamic?: boolean;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  leadListId?: string;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  leadListKey?: string;
  /**
   * Campaign name for display
   * @type {string}
   * @memberof Campaign
   */
  name?: string;
  /**
   * Number of lead items
   * @type {number}
   * @memberof Campaign
   */
  numItems?: number;
  /**
   * Number of pending lead items
   * @type {number}
   * @memberof Campaign
   */
  numPending?: number;
  /**
   * percent progress of campaign execution 0.0 - 1.0
   * @type {number | null}
   * @memberof Campaign
   */
  progress?: number | null;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  settingsId?: string;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  settingsKey?: string;
  /**
   *
   * @type {string | null}
   * @memberof Campaign
   */
  sortName?: string | null;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  state?: CampaignStateEnum;
  /**
   * Dialing strategy for the campaign
   * @type {string}
   * @memberof Campaign
   */
  strategy?: CampaignStrategyEnum;
  /**
   *
   * @type {Array<any>}
   * @memberof Campaign
   */
  tags?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  targetId?: string;
  /**
   *
   * @type {string}
   * @memberof Campaign
   */
  targetKey?: string;
}

/**
 * @export
 */
export const CampaignStateEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
} as const;
export type CampaignStateEnum =
  (typeof CampaignStateEnum)[keyof typeof CampaignStateEnum];

/**
 * @export
 */
export const CampaignStrategyEnum = {
  Progressive: 'progressive',
  Predictive: 'predictive',
  Preview: 'preview',
} as const;
export type CampaignStrategyEnum =
  (typeof CampaignStrategyEnum)[keyof typeof CampaignStrategyEnum];

/**
 * Check if a given object implements the Campaign interface.
 */
export function instanceOfCampaign(value: object): value is Campaign {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function CampaignFromJSON(json: any): Campaign {
  return CampaignFromJSONTyped(json, false);
}

export function CampaignFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Campaign {
  if (json == null) {
    return json;
  }
  return {
    authorId: json['author_id'] == null ? undefined : json['author_id'],
    authorKey: json['author_key'] == null ? undefined : json['author_key'],
    callerId: json['caller_id'] == null ? undefined : json['caller_id'],
    campaignId: json['campaign_id'] == null ? undefined : json['campaign_id'],
    companyId: json['company_id'],
    dateArchived:
      json['date_archived'] == null ? undefined : json['date_archived'],
    dateArchivedIso:
      json['date_archived_iso'] == null ? undefined : json['date_archived_iso'],
    dateAudienceComputed:
      json['date_audience_computed'] == null
        ? undefined
        : json['date_audience_computed'],
    dateAudienceComputedIso:
      json['date_audience_computed_iso'] == null
        ? undefined
        : json['date_audience_computed_iso'],
    dateComputed:
      json['date_computed'] == null ? undefined : json['date_computed'],
    dateComputedIso:
      json['date_computed_iso'] == null ? undefined : json['date_computed_iso'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateEnded: json['date_ended'] == null ? undefined : json['date_ended'],
    dateEndedIso:
      json['date_ended_iso'] == null ? undefined : json['date_ended_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    datePaused: json['date_paused'] == null ? undefined : json['date_paused'],
    datePausedIso:
      json['date_paused_iso'] == null ? undefined : json['date_paused_iso'],
    dateScheduledEnd:
      json['date_scheduled_end'] == null
        ? undefined
        : json['date_scheduled_end'],
    dateScheduledEndIso:
      json['date_scheduled_end_iso'] == null
        ? undefined
        : json['date_scheduled_end_iso'],
    dateScheduledStart:
      json['date_scheduled_start'] == null
        ? undefined
        : json['date_scheduled_start'],
    dateScheduledStartIso:
      json['date_scheduled_start_iso'] == null
        ? undefined
        : json['date_scheduled_start_iso'],
    dateStarted:
      json['date_started'] == null ? undefined : json['date_started'],
    dateStartedIso:
      json['date_started_iso'] == null ? undefined : json['date_started_iso'],
    description: json['description'] == null ? undefined : json['description'],
    flowId: json['flow_id'] == null ? undefined : json['flow_id'],
    flowKey: json['flow_key'] == null ? undefined : json['flow_key'],
    gcsFilename:
      json['gcs_filename'] == null ? undefined : json['gcs_filename'],
    groupId: json['group_id'] == null ? undefined : json['group_id'],
    id: json['id'],
    isDynamic: json['is_dynamic'] == null ? undefined : json['is_dynamic'],
    key: json['key'],
    leadListId: json['lead_list_id'] == null ? undefined : json['lead_list_id'],
    leadListKey:
      json['lead_list_key'] == null ? undefined : json['lead_list_key'],
    name: json['name'] == null ? undefined : json['name'],
    numItems: json['num_items'] == null ? undefined : json['num_items'],
    numPending: json['num_pending'] == null ? undefined : json['num_pending'],
    progress: json['progress'] == null ? undefined : json['progress'],
    settingsId: json['settings_id'] == null ? undefined : json['settings_id'],
    settingsKey:
      json['settings_key'] == null ? undefined : json['settings_key'],
    sortName: json['sort_name'] == null ? undefined : json['sort_name'],
    state: json['state'] == null ? undefined : json['state'],
    strategy: json['strategy'] == null ? undefined : json['strategy'],
    tags: json['tags'] == null ? undefined : json['tags'],
    targetId: json['target_id'] == null ? undefined : json['target_id'],
    targetKey: json['target_key'] == null ? undefined : json['target_key'],
  };
}

export function CampaignToJSON(value?: Campaign | null): any {
  if (value == null) {
    return value;
  }
  return {
    author_id: value['authorId'],
    author_key: value['authorKey'],
    caller_id: value['callerId'],
    campaign_id: value['campaignId'],
    company_id: value['companyId'],
    date_archived: value['dateArchived'],
    date_archived_iso: value['dateArchivedIso'],
    date_audience_computed: value['dateAudienceComputed'],
    date_audience_computed_iso: value['dateAudienceComputedIso'],
    date_computed: value['dateComputed'],
    date_computed_iso: value['dateComputedIso'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_ended: value['dateEnded'],
    date_ended_iso: value['dateEndedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    date_paused: value['datePaused'],
    date_paused_iso: value['datePausedIso'],
    date_scheduled_end: value['dateScheduledEnd'],
    date_scheduled_end_iso: value['dateScheduledEndIso'],
    date_scheduled_start: value['dateScheduledStart'],
    date_scheduled_start_iso: value['dateScheduledStartIso'],
    date_started: value['dateStarted'],
    date_started_iso: value['dateStartedIso'],
    description: value['description'],
    flow_id: value['flowId'],
    flow_key: value['flowKey'],
    gcs_filename: value['gcsFilename'],
    group_id: value['groupId'],
    id: value['id'],
    is_dynamic: value['isDynamic'],
    key: value['key'],
    lead_list_id: value['leadListId'],
    lead_list_key: value['leadListKey'],
    name: value['name'],
    num_items: value['numItems'],
    num_pending: value['numPending'],
    progress: value['progress'],
    settings_id: value['settingsId'],
    settings_key: value['settingsKey'],
    sort_name: value['sortName'],
    state: value['state'],
    strategy: value['strategy'],
    tags: value['tags'],
    target_id: value['targetId'],
    target_key: value['targetKey'],
  };
}
